import {runInjector} from '../_libs/angular-utils';
import {ListItem} from './lists/ListItem/ListItem';


const angular = require('angular');

module.exports = angular
  .module('app.components', [])
  .run(runInjector(ListItem))
;



// WEBPACK FOOTER //
// ./src/js/components/index.js